module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-144x144-6b0688aedf34677236a05b6e02bdcb2b.png";